export default {
    pcd: "43A",
    pname: "熊本県",
    header: "熊本県 GoToEat 食事券申込",
    cid: "ekumamoto",
    unitdetails: "12,000円（1,000円×12枚）／1セット",
    ticketvalue: 12000,
    unitprice: 10000,
    maxunits: 2,
    quantityoptions: [
        {value: "1", text: "1"},
        {value: "2", text: "2"}
    ],
    starttime: "0:00"
};
